<template>
  <!-- Why choose us (S_Compare): a tick list, or "us vs typical" as a table. -->
  <SectionBand :heading="section.heading || section.title" :variant="variant" :background="section.background" label="Why choose us">
    <table v-if="layout === 'table'" class="s2-compare">
      <thead><tr><th scope="col"><span class="sr-only">What</span></th><th scope="col">{{ section.usLabel || 'Us' }}</th><th scope="col">{{ section.themLabel || 'Typical' }}</th></tr></thead>
      <tbody>
        <tr v-for="(r, i) in rows" :key="i">
          <th scope="row">{{ r.label }}</th>
          <td class="s2-compare__us">{{ r.us || '✓' }}</td>
          <td class="t-muted">{{ r.them || '—' }}</td>
        </tr>
      </tbody>
    </table>
    <ul v-else class="s2-ticklist mo-stagger">
      <li v-for="(r, i) in rows" :key="i"><span aria-hidden="true" class="s2-tick">✓</span><span><strong>{{ r.label }}</strong><template v-if="r.us && r.us !== '✓'"> — {{ r.us }}</template></span></li>
    </ul>
  </SectionBand>
</template>

<script setup>
import {computed} from "vue";
import SectionBand from "../shared/SectionBand.vue";

const props = defineProps({section: {type: Object, required: true}, variant: {type: [Number, String], default: 1}});
const layout = computed(() => (props.section.layout === "table" ? "table" : "ticks"));
// Rows: {label, us, them}; the studio's generic {label, value} reads as "us".
const rows = computed(() => (Array.isArray(props.section.rows) ? props.section.rows : [])
  .map((r) => (typeof r === "string" ? {label: r} : {label: r?.label || "", us: r?.us ?? r?.value ?? "", them: r?.them ?? ""}))
  .filter((r) => r.label));
</script>

<style scoped>
.s2-compare { width: 100%; border-collapse: collapse; font-family: var(--t-font-body); }
.s2-compare th, .s2-compare td { text-align: left; padding: .85rem .6rem; border-bottom: 1px solid var(--t-line); }
.s2-compare thead th { font-size: .78rem; letter-spacing: .12em; text-transform: uppercase; color: var(--t-muted); }
.s2-compare tbody th { font-weight: 600; }
.s2-compare__us { color: var(--t-accent); font-weight: 700; }
.s2-ticklist { list-style: none; padding: 0; margin: 0; display: grid; gap: .7rem; grid-template-columns: repeat(auto-fit, minmax(min(280px, 100%), 1fr)); }
.s2-ticklist li { display: flex; gap: .6rem; align-items: baseline; }
.s2-tick { color: var(--t-accent); font-weight: 800; }
.sr-only { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); }
</style>
